import styled from "styled-components"

export const GridContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
`

export const GridHeader = styled.div`
  display: grid;
  grid-template-columns: 200px repeat(5, 1fr);
  background-color: #F5F5F5;
`

export const HeaderCell = styled.div`
  padding: 16px;
  font-weight: 600;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const GridBody = styled.div`
  max-height: calc(100vh - 250px);
  overflow-y: auto;
`
